export class Status_Objets {
  description: string;
  profilVisualisationId: number;
  profilVisualisationIdLabel: string;
  profilUtilisationId: number;
  profilUtilisationIdLabel: string;
  profilModificationId: number;
  profilModificationIdLabel: string;
  droitsTableauDeBord: number;
  droitsTableauDeBordLabel: string;
  statutAutiliserLorsCreation: boolean = false;
  validePourAjoutSeance: boolean = false;
  statutAutiliserLorsDeAnnulation: boolean = false;
  viderDecision: boolean = false;
  typeReport: boolean = false;
  visibleTableauDeBord: boolean = false;
  backcolor: boolean = false;
  modeleAvisDfnecessaire: boolean = false;
  exclureVerrouilles: boolean = false;
  exclureClotures: boolean = false;
  groupeSecuriteFichierAjout: number;
  groupeSecuriteFichierAjoutLabel: string;
  groupeSecuriteFichierSuppression: number;
  groupeSecuriteFichierSuppressionLabel: string;
  groupeSecuriteFichierModification: number;
  groupeSecuriteFichierModificationLabel: string;
  utilisable: boolean = false;
  backcolorDiv: string;
  id: number;
  constructor(data: any, userProfils?) {
    Object.assign(this, data);
    if (this.backcolor) {
      this.backcolorDiv = `<div style="background-color:${this.backcolor};width:100px; height:25px"></div>`;
    }

    if (userProfils && userProfils.length > 0) {
      if (this.profilVisualisationId) {
        this.profilVisualisationIdLabel = userProfils.find((x) => x.id === this.profilVisualisationId).description;
      }
      if (this.profilUtilisationId) {
        this.profilUtilisationIdLabel = userProfils.find((x) => x.id === this.profilUtilisationId).description;
      }
      if (this.profilModificationId) {
        this.profilModificationIdLabel = userProfils.find((x) => x.id === this.profilModificationId).description;
      }
      if (this.droitsTableauDeBord) {
        this.droitsTableauDeBordLabel = userProfils.find((x) => x.id === this.droitsTableauDeBord).description;
      }
    }
  }
}
